import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root'
})
export class PaginatorService {
  private readonly pageEventSubject = new BehaviorSubject<PageEvent>({
    pageIndex: 0,
    pageSize: 10,
    length: 0
  });

  pageEvent$ = this.pageEventSubject.asObservable();

  updatePageEvent(event: PageEvent) {
    this.pageEventSubject.next(event);
  }
}
